"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTradeCurrentClient = exports.getTradeOldClient = exports.revertToCurrentTrade = exports.revertToOldTrade = exports.convertCurrentTrades = exports.convertOldTrades = exports.getOldTradeState = void 0;
const escrow_sdk_old_1 = require("escrow-sdk-old");
const index_1 = require("../../index");
const types_1 = require("../types");
const anchor_1 = require("@project-serum/anchor");
const consts_1 = require("./consts");
const getOldTradeState = (tradeState) => {
    const tradeKeys = Object.keys(index_1.TradeState);
    const tradeKey = tradeKeys.find((key) => index_1.TradeState[key] === tradeState);
    if (!tradeKey) {
        throw new Error("Invalid trade state");
    }
    return escrow_sdk_old_1.OrderState[tradeKey];
};
exports.getOldTradeState = getOldTradeState;
const convertOldTrades = (trades) => {
    return trades
        .map((trade) => {
        if (!trade)
            null;
        return Object.assign(Object.assign({}, trade), { offerId: new anchor_1.BN(0), tradeId: trade.orderId, tradeIdSeed: trade.orderIdSeed, configRentVault: consts_1.NULL_PUBKEY, version: types_1.Version.Old, pubkey: consts_1.NULL_PUBKEY });
    })
        .filter(Boolean);
};
exports.convertOldTrades = convertOldTrades;
const convertCurrentTrades = (trades) => {
    return trades.map((trade) => {
        return Object.assign(Object.assign({}, trade), { joinedAt: trade.createdAt, version: types_1.Version.Current });
    });
};
exports.convertCurrentTrades = convertCurrentTrades;
const revertToOldTrade = (trade) => {
    const { offerId, tradeId, tradeIdSeed, version } = trade, rest = __rest(trade, ["offerId", "tradeId", "tradeIdSeed", "version"]);
    return Object.assign(Object.assign({}, rest), { orderId: tradeId, orderIdSeed: tradeIdSeed });
};
exports.revertToOldTrade = revertToOldTrade;
const revertToCurrentTrade = (trade) => {
    const { version, joinedAt } = trade, rest = __rest(trade, ["version", "joinedAt"]);
    return rest;
};
exports.revertToCurrentTrade = revertToCurrentTrade;
const getTradeOldClient = (ctx, configId, tradeData) => {
    const pda = new escrow_sdk_old_1.PDA(ctx.program.programId, configId);
    const tradePubkey = pda.getTradeOrderPDA(tradeData.tradeId).key;
    return new escrow_sdk_old_1.TradeOrderClient(ctx, tradePubkey, (0, exports.revertToOldTrade)(tradeData), pda, configId);
};
exports.getTradeOldClient = getTradeOldClient;
const getTradeCurrentClient = (ctx, configId, tradeData) => {
    const pda = new index_1.PDA(ctx.program.programId, configId);
    const tradePubkey = pda.getTradePDA(tradeData.tradeId).key;
    return new index_1.TradeClient(ctx, tradePubkey, (0, exports.revertToCurrentTrade)(tradeData), pda, configId);
};
exports.getTradeCurrentClient = getTradeCurrentClient;
